import { useNavigate } from 'react-router-dom';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function AboutSunshine() {
  const navigate = useNavigate();
  const { ref, isVisible } = useScrollReveal();

  const values = [
    'Verified, legally-sound projects only',
    'Expert project marketing and sales strategy',
    'Personalized investment consultation for every client',
    'End-to-end documentation and booking support',
  ];

  return (
    <section className="w-full py-16 md:py-24 bg-charcoal-300">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div ref={ref} className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center max-w-6xl mx-auto">
          {/* Image */}
          <div className={`relative ${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`}>
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=modern%20luxury%20real%20estate%20office%20interior%20with%20friendly%20professional%20team%20meeting%20warm%20ambiance%20natural%20light%20premium%20corporate%20environment%20Pakistan%20business%20classy%20modern%20design&width=800&height=600&seq=401&orientation=landscape"
                alt="Sunshine Real Estate Team"
                className="w-full h-72 md:h-96 object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-brand-green/20 to-transparent" />
            </div>
            {/* Floating stat */}
            <div className="absolute -bottom-5 -right-2 md:right-5 bg-white rounded-xl p-4 shadow-xl">
              <div className="text-2xl md:text-3xl font-extrabold text-brand-orange">7+</div>
              <div className="text-xs text-charcoal-50 font-medium">Years of Excellence</div>
            </div>
          </div>

          {/* Content */}
          <div className={`${isVisible ? 'animate-fade-in-up' : 'opacity-0'}`} style={{ animationDelay: '0.15s' }}>
            <span className="inline-block text-xs md:text-sm font-semibold text-brand-orange uppercase tracking-widest mb-3">
              Who We Are
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-white mb-5">
              Your Trusted Real Estate Investment Partner
            </h2>
            <p className="text-sm md:text-base text-ivory-300 leading-relaxed mb-4">
              Sunshine Real Estate Marketing SMC (Pvt.) Ltd. is Pakistan's premier real estate marketing and investment consultancy firm. We bridge the gap between property developers and serious investors with verified, high-potential opportunities.
            </p>
            <p className="text-sm md:text-base text-ivory-300 leading-relaxed mb-6">
              From residential plots in Islamabad to commercial ventures across major cities, our team provides end-to-end support — including expert project marketing, transparent investment consultation, secure documentation assistance, and personalized site visit coordination.
            </p>

            <ul className="flex flex-col gap-3 mb-8">
              {values.map((v, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="w-6 h-6 flex items-center justify-center rounded-full bg-brand-green/20 shrink-0 mt-0.5">
                    <i className="ri-check-line text-brand-green text-sm" />
                  </span>
                  <span className="text-sm md:text-base text-ivory-200">{v}</span>
                </li>
              ))}
            </ul>

            <button
              onClick={() => { navigate('/about'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="px-6 py-3 bg-white text-charcoal-300 text-sm md:text-base font-semibold rounded-lg hover:bg-ivory-100 transition-all duration-300 shadow-md hover:shadow-lg hover:-translate-y-0.5"
            >
              Learn More About Us
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}